import React from "react"
import { Link, graphql } from "gatsby"
import { IconContext } from "react-icons";
import IconItem from "./IconItem"
import { MdKeyboardReturn } from 'react-icons/md';

export default function BackButton() {
  return (
    <div>
      <IconItem
        to="/estacades"
        title="Revenir à la liste des bateaux"
        subtitle=""
        icon={MdKeyboardReturn}
      />
    </div>
  )
}
